import Tab from "@mui/material/Tab";
import { useState } from "react";
import type { FunctionComponent } from "react";

import { OlympicTodayHighlightsItem } from "~/components/olympic-widgets/today-highlights/today-highlights-item";
import { OlympicTodayHighlightsTabPanel } from "~/components/olympic-widgets/today-highlights/today-highlights-tab-panel";
import type { GetOlympicEvents } from "~/components/olympic-widgets/today-highlights/types";

import { Container, EmptySchedule, StyledTabs, TabPanelContainer } from "./styles";

type Props = {
  className?: string;
  tabData: GetOlympicEvents;
};

function a11yProps(index: number) {
  return {
    tab: {
      "aria-controls": `today-highlights-tabpanel-${index}`,
      id: `today-highlights-tab-${index}`,
    },
    tabPanel: {
      "aria-labelledby": `today-highlights-tabpanel-${index}`,
      id: `today-highlights-tab-${index}`,
    },
  };
}

export const OlympicTodayHighlightsTabs: FunctionComponent<Props> = ({ className, tabData }) => {
  const [tabValue, setTabValue] = useState(tabData["hk"].length === 0 ? 1 : 0);
  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const placeMapping: { [key: string]: string } = {
    china: "CHINA",
    hk: "HONG KONG",
  };

  const customOrder = ["hk", "china"] as const;

  return (
    <Container className={className}>
      <StyledTabs value={tabValue} centered onChange={handleChange}>
        {customOrder.map((key, index) => (
          <Tab key={key} label={placeMapping[key]} {...a11yProps(index).tab} disableRipple />
        ))}
      </StyledTabs>
      <TabPanelContainer>
        {customOrder.map((key, index) => {
          const data = tabData[key];
          return (
            <OlympicTodayHighlightsTabPanel
              index={index}
              key={key}
              value={tabValue}
              {...a11yProps(index).tabPanel}
            >
              {data.length > 0 ? (
                data.map((item, valueIndex) => (
                  <OlympicTodayHighlightsItem key={valueIndex} {...item} />
                ))
              ) : (
                <EmptySchedule>
                  {tabValue === 0
                    ? "There are no Hong Kong athletes in action today"
                    : "There are no China athletes in action today"}
                </EmptySchedule>
              )}
            </OlympicTodayHighlightsTabPanel>
          );
        })}
      </TabPanelContainer>
    </Container>
  );
};

OlympicTodayHighlightsTabs.displayName = "OlympicTodayHighlightsTabs";
